import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import ArticleDetail from './components/ArticleDetail';

export default function Article() {
  return (
    <>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <ArticleDetail />
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}